var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChildDevelopmentSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 59,
    viewBox: "0 0 71 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.9648 24.7393C60.716 25.015 60.5782 25.3731 60.5782 25.7445V51.6184C60.5782 52.0551 60.3402 52.4749 59.7319 52.859C59.1047 53.2551 58.309 53.4491 57.7796 53.4491C56.9302 53.4491 56.1713 53.2308 55.672 52.8892C55.2218 52.5813 54.981 52.1874 54.981 51.6184V39.5564C54.981 38.728 54.3094 38.0564 53.481 38.0564H50.6153C49.7868 38.0564 49.1153 38.728 49.1153 39.5564V51.6184C49.1153 52.3093 48.8783 52.6736 48.5455 52.9174C48.1443 53.2114 47.4269 53.4491 46.3166 53.4491C45.2064 53.4491 44.489 53.2114 44.0878 52.9174C43.755 52.6736 43.518 52.3093 43.518 51.6184V25.7445C43.518 25.3731 43.3803 25.015 43.1314 24.7393L35.0118 15.7461C34.9903 15.7222 34.968 15.6991 34.945 15.6767C34.6545 15.3938 34.5 15.0302 34.5 14.6264C34.5 14.6277 34.5002 14.6269 34.5008 14.6239C34.5054 14.6011 34.5355 14.4526 34.7112 14.1743C34.8837 13.9013 35.1192 13.6259 35.34 13.4075C35.4158 13.3408 35.4856 13.2789 35.5507 13.2209C35.7985 13.0007 35.9806 12.8388 36.1826 12.7002C36.3959 12.5538 36.4855 12.5419 36.4937 12.5412C36.9445 12.5414 37.3365 12.7067 37.6282 12.9908C37.675 13.0364 37.7248 13.0789 37.7772 13.118L47.9257 20.6966C48.1849 20.8902 48.4997 20.9948 48.8232 20.9948H51.9679H54.9842C55.3103 20.9948 55.6274 20.8885 55.8877 20.6921L66.0535 13.0214C66.1037 12.9836 66.1515 12.9426 66.1965 12.8987C66.4885 12.6144 66.8808 12.4491 67.332 12.4491C67.3286 12.4491 67.3269 12.4491 67.3268 12.4493C67.3266 12.4512 67.4517 12.4699 67.725 12.6564C68.0044 12.8471 68.2883 13.1079 68.57 13.3822C69.1033 13.9016 69.4203 14.3515 69.4801 14.8174C69.5238 15.1576 69.4832 15.2613 69.4749 15.2826L69.4747 15.283C69.4604 15.3197 69.4112 15.4236 69.1513 15.6767C69.1283 15.6991 69.106 15.7222 69.0844 15.7461L60.9648 24.7393Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 57L61 57",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 42,
    width: 6,
    height: 11,
    rx: 3,
    stroke: "white",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 37,
    width: 6,
    height: 16,
    rx: 3,
    stroke: "white",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 31,
    width: 6,
    height: 22,
    rx: 3,
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 37.2202C12.4107 35.9583 26.6071 29.3333 32.2857 20.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6365 3.92306C57.963 5.20511 58.6262 6.77852 58.6262 8.58503C58.6262 10.3915 57.963 11.965 56.6365 13.247C55.3101 14.529 53.6822 15.1701 51.8131 15.1701C49.944 15.1701 48.3161 14.529 46.9897 13.247C45.6632 11.965 45 10.3915 45 8.58503C45 6.77852 45.6632 5.20511 46.9897 3.92306C48.3161 2.64102 49.944 2 51.8131 2C53.6822 2 55.3101 2.64102 56.6365 3.92306Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20.5L32.5 20L34 25.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildDevelopmentSelected);
export default __webpack_public_path__ + "static/media/childDevelopmentSelected.08d005ee.svg";
export { ForwardRef as ReactComponent };